<template>
  <v-card class="support-faq pa-3">
    <v-row>
      <v-col cols="12" md="6" v-for="(f, index) in faqs" :key="`faq-${index}`">
        <v-card flat class="mt-4">
          <v-card-actions>
            <h2 class="subheaders">{{ f.title }}</h2>
            <v-spacer />
          </v-card-actions>
          <div v-for="(item, index) in f.items" :key="`${f.type}-${index}`">
            <v-card-actions>
              <a @click="showDialog(f, item)">
                {{ item.question }}
              </a>
              <v-spacer />
              <v-btn text icon color="primary" @click="showDialog(f, item)">
                <v-icon>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="600" content-class="faq-dialog">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title class="white--text">
            FAQ - {{ selectedCategory.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="dialog = false" text>
              <v-icon small class="pr-2">close</v-icon>
              close
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pa-4">
          <h4 class="faq-title">{{ selectedFaq.question }}</h4>
          <p v-if="isSDECC === false" class="mt-4">{{ selectedFaq.answer }}</p>
          <p v-else class="mt-4" v-html="selectedFaq.answer"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'Faq',
  props: {
    faqs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      selectedCategory: {},
      selectedFaq: {},
      isSDECC: false
    }
  },
  mounted() {
    if (this.$store.state.isSDECC == 1) {
      this.isSDECC = true
    }
  },
  computed: {},
  methods: {
    showDialog(faqCategory, faq) {
      this.dialog = true
      this.selectedFaq = faq
      this.selectedCategory = faqCategory
    }
  }
}
</script>

<style lang="scss">
html body .support-faq {
  .subheaders {
    color: var(--v-primary-base);
  }

  a {
    color: rgba(0, 0, 0, 0.87);
  }
}

.faq-dialog {
  .faq-title {
    font-weight: 500;
    font-size: 20px;
  }
}
</style>
